<template lang="pug">
v-container
  br
  v-row
    v-html(style="width: 100% !important; text-align: center") <h1>{{ $t('transactions') }}</h1>
  br
  v-row
    v-col
    v-col
      v-radio-group.nufi-radio(row, label="NUFI" v-model="enviroment")
        v-row                  
          v-col
            v-radio(v-bind:label='$t("sandbox")', light, value="sandbox").float-right
          v-col
            v-radio(v-bind:label='$t("production")', value="production")        
    v-col
  v-row
    v-col
    v-col.update
      | Última actualizacion: {{lastUpdateFormated}}
    v-col
  hr
  br
  br
  .middle 
    v-card.mx-auto(max-width="100%" flat)
      v-card-title 
        h3 Nº {{ $t('transactions') }}
      v-card-text
        v-row
          v-col
            a(@click="last7") Últimos 7 días
          v-col
            a(@click="currentMoth") Mes en curso
          v-col
            v-row
              v-col(cols="2")
                span.dates Fechas
              v-col(cols="10")
                v-menu(
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto")
                  template(v-slot:activator="{ on, attrs }")
                    v-text-field(                                        
                      v-model="dates"                  
                      readonly
                      dense
                      v-bind="attrs"
                      v-on="on")                              
                  v-date-picker(
                    v-model="dates"
                    range
                    @input="changeDates")            
        v-divider
        v-container.mt-10
          v-progress-linear(
            indeterminate
            color="primary"
            v-if="loading")  
          v-row(v-else)
            v-row
              v-col
                div.card.yellow.darken-1.text--white
                  v-icon(color="white") mdi-alert-circle-outline                   
                  div {{$t('callCountTotal')}}                 
                  div {{report.callCountFailed +report.callCountSuccess}}
              v-col
                div.card.green.darken-2
                  v-icon(color="white") mdi-check-circle-outline 
                  div {{$t('callCountSuccess')}}
                  div {{report.callCountSuccess}}                
              v-col
                div.card.deep-orange.darken-2
                  v-icon(color="white") mdi-alert-outline
                  div {{$t('callCountFailed')}}
                  div {{report.callCountFailed}}
          //- v-row(style="text-align:center; width:100%")
          //-     v-html(style="text-align:center; width:100%") <br /><b> {{ $t('nodatalastmonth') }} </b>

</template>
<script>
export default {
  data() {
    return {
      enviroment: 'production',
      report: {},
      loading: false,
      lastUpdate: null,
      dates: [],
      menu: false
    }
  },
  computed: {
    lastUpdateFormated() {      
    const d = this.lastUpdate ? this.lastUpdate : new Date();
    const ye = new Intl.DateTimeFormat('es-MX', { year: 'numeric' }).format(d);
    const mo = new Intl.DateTimeFormat('es-MX', { month: '2-digit' }).format(d);
    const da = new Intl.DateTimeFormat('es-MX', { day: '2-digit' }).format(d);    
    const tt = d.toLocaleString('en-MX', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })
    return `${da}/${mo}/${ye} ${tt}`;
    }
  },
  methods: {
    changeDates() {
      if(this.dates.length === 2)
      {
        this.menu = false;
        this.get();
      }
    },
    last7() {
      this.dates = [
        this.$moment().add(-7, 'd').format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD")
      ];
      this.get();
    },
    currentMoth() {
      this.dates = [
        this.$moment().format("YYYY-MM-01"),
        this.$moment().format("YYYY-MM-DD")
      ];
      this.get();
    },
    get() {
      this.loading = true;
      this.$store.dispatch("reportOperationsGet", {Dates: this.dates}).then(response => {      
        if(response.status === 200) {
          this.report = response.data;
          this.lastUpdate = new Date();
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  created() {
    this.get();
  },
}
</script>
<style scoped>
.card {
  width: 50%;
  height: 180px;
  border-radius: 8px;
  text-align: center;
  color: white;
  padding-top: 15px;  
  margin: auto;
  font-size: 30px;
  line-height: 50px;
}
.nufi-radio legend{
  color: blue!important;
}
.update {
  font-weight: bold;
  text-align: center;
  margin-bottom: 12px;  
}
.dates {
  font-size: 16px;
  color: black;
}

</style>
